import * as React from 'react';
import { observer } from 'mobx-react';
import { ITranslationsCollection, translate } from 'elc-service';
import styled from 'styled-components';
import { ContentSpacing } from 'elc-base-theme';
import { Body2 } from 'elc-typography';
import { formatDateFromString } from '../../utils/DateFormat';
import {
    PREORDER_NOT_AVAILABLE_MESSAGE,
    SHIPS_BY_MESSAGE
} from '../../constants/DataTestIdAttributes';

export interface IPreorderMessage {
    preorderDate: string;
    isPreorderActive: boolean;
    translations?: ITranslationsCollection;
}

const StyledBlock = styled.div`
    margin: ${ContentSpacing.space24} 0;
`;

export const buildMessageText = (props: IPreorderMessage) => {
    const { preorderDate, isPreorderActive, translations } = props;
    const {
        preorderNotAvailableMessage = '',
        shipsBy = ''
    } = translations as ITranslationsCollection;

    let message = '';
    const formattedDate = formatDateFromString(preorderDate);
    const { day, month } = formattedDate;

    if (isPreorderActive) {
        message = shipsBy.replace(/::PREORDER_DATE::/gi, `${day}/${month}`);
    } else {
        message = preorderNotAvailableMessage.replace(/::PREORDER_DATE::/gi, `${day}/${month}`);
    }

    return message;
};

export const PreorderMessage: React.FunctionComponent<IPreorderMessage> = translate([
    'shipsBy',
    'preorderNotAvailableMessage'
])(
    observer((props: IPreorderMessage) => {
        const message = buildMessageText(props);

        return (
            <StyledBlock className={'elc-preorder-message-block'}>
                {props.isPreorderActive ? (
                    <Body2
                        className={'elc-preorder-ships-by-message'}
                        data-test-id={SHIPS_BY_MESSAGE}
                        dangerouslySetInnerHTML={{ __html: message }}
                    />
                ) : (
                    <Body2
                        className={'elc-preorder-not-available-message'}
                        data-test-id={PREORDER_NOT_AVAILABLE_MESSAGE}
                        dangerouslySetInnerHTML={{ __html: message }}
                    />
                )}
            </StyledBlock>
        );
    })
);
